import React, { useEffect, useMemo, useState } from "react";

import PaginationNumeric from "../../components/PaginationNumeric.jsx";
import { getStripeSubscriptions, getMerchants } from "../../api/admin.js";
import { getMerchants as appGetMerchants } from "../../store/app/action.js";
import {useDispatch, useSelector} from "react-redux";
import MerchantTable from "./merchantTable.jsx";
import { isMerchantOffboarded } from "./merchantTableItem.jsx";
import ToggleSwitch from "../../components/ToggleSwitch.jsx";
import {FaCrown} from "react-icons/fa6";

function Merchants() {
  const [selectedItems, setSelectedItems] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortedMerchants, setSortedMerchants] = useState([]);
  const { selectedMerchant } = useSelector((state) => state.app);
  const [subscriptions, setSubscriptions] = useState([]);
  const [showOffboarded, setShowOffboarded] = useState(false);
  const dispatch = useDispatch();
  const totalPages = useMemo(() => {
    return Math.ceil(totalRecords / limit);
  }, [totalRecords, limit]);

  const handleSelectedItems = (selectedItems) => {
    setSelectedItems([...selectedItems]);
  };

  const _getMerchants = () => {
    dispatch(appGetMerchants());
    getMerchants(page, limit).then((res) => {
      setMerchants(res.merchants);
    });
    getStripeSubscriptions().then((res) => {
      setSubscriptions(res || []);
    });
  };

  useEffect(() => {
    if(!merchants || !merchants.length){
      return ;
    }
    if(!selectedMerchant){
      setSortedMerchants(merchants)
    }else{
      // put selected merchant on top
      const selected = merchants.find((merchant) => merchant.id === selectedMerchant.id);
      const rest = merchants.filter((merchant) => merchant.id !== selectedMerchant.id);
      setSortedMerchants([selected, ...rest]);
    }
  }, [merchants, selectedMerchant]);

  const visibleMerchants = useMemo(() => {
    if (showOffboarded) return sortedMerchants;
    return sortedMerchants.filter((merchant) => !isMerchantOffboarded(merchant));
  }, [sortedMerchants, showOffboarded]);
  useEffect(() => {
    _getMerchants();
  }, [page, limit]);


  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      {/* Page header */}
      <div className="sm:flex sm:justify-between sm:items-center mb-8">
        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold flex items-center gap-1">
            Merchant Accounts <FaCrown />
          </h1>
        </div>
        <div className="text-sm text-slate-600 dark:text-slate-300">
          <ToggleSwitch
            checked={showOffboarded}
            onChange={setShowOffboarded}
            onLabel="Show offboarded"
            offLabel="Show offboarded"
            label="Show offboarded merchants"
          />
        </div>
      </div>

      <MerchantTable
        merchants={visibleMerchants}
        emptyMessage={
          !showOffboarded && sortedMerchants.length > 0
            ? "Offboarded merchants are hidden."
            : "No merchants to show."
        }
        selectedItems={handleSelectedItems}
        getMerchants={_getMerchants}
        subscriptions={subscriptions}
      />

      {/* Pagination */}
      <div className="mt-8">
        <PaginationNumeric
          onSelect={(p) => setPage(p + 1)}
          currentPage={page - 1}
          totalPages={totalPages}
          isFirstPage={page === 1}
          isLastPage={page === totalPages}
        />
      </div>
    </div>
  );
}

export default Merchants;
